import jwt from 'jsonwebtoken';
import stompWebsocket from '@/shared/utils/stompWebsocket';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { useRef } from 'react';
import { constant } from '../utils/constant';
import { request } from '../io';
import dayjs from 'dayjs';
import { getApiUrl } from '../utils';
const Base64 = require('js-base64').Base64;
const appId = 'xWIqqaOPHQqJ';
const appSecret = '2a06IArpGsVH9qLH8C1U1';
const BasicSecret = Base64.encode(`${appId}:${appSecret}`);
const pathname = window.location.pathname;
function getParam(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    var r = window.location.search.substr(1).match(reg);
    if (r != null)
        return decodeURI(r[2]);
    return null;
}
async function authLogin(params) {
    if (await getParam('access_token')) {
        const sToken = await getParam('access_token');
        sessionStorage.setItem('ACCESS_TOKEN', sToken);
        // 解析token获取用户信息
        const access_token = sessionStorage.getItem('ACCESS_TOKEN');
        const aToken = jwt.decode(access_token);
        sessionStorage.setItem('USER_INFO', JSON.stringify(aToken.user_info));
        // const path = window.location.href.split('?')[0];
        const href0 = window.location.href.split('?')[0];
        const href1 = window.location.href.split('?')[1];
        let params = '';
        if (href1) {
            const paths = href1.split('&');
            const pathUrl = paths.filter((item) => !item.includes('access_token') && !item.includes('ACCESS_TOKEN'));
            console.log(pathUrl);
            params = pathUrl.join('&');
        }
        const result = `${href0}?${params}`;
        window.location.href = result;
    }
    if (await getParam('ACCESS_TOKEN')) {
        const sToken = await getParam('ACCESS_TOKEN');
        sessionStorage.setItem('ACCESS_TOKEN', sToken);
        // 解析token获取用户信息
        const access_token = sessionStorage.getItem('ACCESS_TOKEN');
        const aToken = jwt.decode(access_token);
        if (aToken.user_info) {
            sessionStorage.setItem('USER_INFO', JSON.stringify(aToken.user_info));
        }
        // const path = window.location.href.split('?')[0];
        // window.location.href = path;
        const href0 = window.location.href.split('?')[0];
        const href1 = window.location.href.split('?')[1];
        let params = '';
        if (href1) {
            const paths = href1.split('&');
            const pathUrl = paths.filter((item) => !item.includes('access_token') && !item.includes('ACCESS_TOKEN'));
            params = pathUrl.join('&');
        }
        const result = `${href0}?${params}`;
        window.location.href = result;
    }
    else if ((await getParam('code')) && !(await isLogin())) {
        const code = await getParam('code');
        accestokenByCode(code, params.configData);
    }
    else if ((await getParam('logout')) === 'yes') {
        deleteToken();
    }
    else {
        if (params.allow.includes(pathname)) {
        }
        else {
            if (await isLogin()) {
                const userinfo = sessionStorage.getItem('USER_INFO');
                return JSON.parse(userinfo);
            }
            else {
                const configData = params.configData ?? {};
                if (configData?.grant_type === 'authorization_code') {
                    let urlHost = '';
                    urlHost =
                        configData?.urlHref || configData?.baseUrl || window.location.href;
                    window.location.href =
                        configData?.authUrl +
                            '/oauth/authorize?response_type=code&client_id=' +
                            appId +
                            '&redirect_uri=' +
                            // @ts-ignore
                            urlHost;
                }
            }
        }
    }
}
/**
 * 请求授权服务器获取token
 * @param code
 */
export async function accestokenByCode(params, config) {
    request('/oauth/token', {
        data: {
            ct: 1,
            grant_type: 'authorization_code',
            code: params,
            redirect_uri: config?.urlHref || config?.baseUrl || window.location.origin,
            fp: localStorage.getItem('fp'),
        },
        headers: {
            Authorization: 'Basic ' + BasicSecret,
        },
        requestType: 'form',
        method: 'post',
    }).then((res) => {
        console.log(res);
        saveToken({
            ...res.data,
            configData: config,
        });
    });
}
/**
 * 是否登陆
 */
export async function isLogin() {
    if (sessionStorage.getItem(constant.access_token)) {
        return true;
    }
    return false;
}
/**
 * 退出登录
 */
export async function logout(e, s) {
    window.sessionStorage.setItem('noclose', 'noclose');
    deleteToken(e, s);
}
/**
 * 删除Token
 */
export async function delToken(e) {
    sessionStorage.removeItem(constant.access_token);
    sessionStorage.removeItem(constant.refresh_token);
    sessionStorage.removeItem(constant.expires_in);
    sessionStorage.removeItem(constant.token_expires_time);
    sessionStorage.removeItem(constant.user_info);
    sessionStorage.removeItem(constant.user_name);
    sessionStorage.removeItem('selectedKeys');
    sessionStorage.removeItem('openKeys');
    localStorage.removeItem('dict_code');
    localStorage.removeItem('sysBasePaths');
    // sessionStorage.clear();
    if (e && e == 1) {
        stompWebsocket?.closeSocket?.();
    }
}
// msg 0 或者不传是发消息登出，其他值不发消息，-99 修改密码所有端登出
export async function deleteToken(e, s, msg, uId) {
    // console.log(s)
    let userInfo = sessionStorage.getItem(constant.user_info);
    const storePtValue = sessionStorage.getItem('pt') || 1;
    if (userInfo) {
        userInfo = JSON.parse(userInfo);
    }
    const userId = uId ? uId : userInfo && userInfo.id ? userInfo.id : '';
    const fp = localStorage.getItem('fp');
    delToken(e);
    const authUrl = getApiUrl();
    const aUrl = (authUrl ? authUrl : window.location.origin) + '/auth';
    if (e && e === 1) {
        const userInfoId = userId && userId != '' ? userId : s ? s : '';
        if (userInfoId && userInfoId != '') {
            window.location.href =
                aUrl + `/logout?ct=1&userId=${userInfoId}&fp=${fp}&pt=${storePtValue}`;
        }
    }
    else {
        const userInfoId = userId && userId != '' ? userId : s ? s : '';
        const amsg = msg || 0;
        console.log(amsg);
        if (userInfoId && userInfoId != '') {
            if (navigator.userAgent.indexOf('Firefox') != -1 ||
                navigator.userAgent.indexOf('Chrome') != -1) {
                window.location.href =
                    aUrl +
                        `/logout?ct=1&userId=${userInfoId}&fp=${fp}&pt=${storePtValue}&msg=${amsg}`;
                setTimeout(() => {
                    closeWindow();
                }, 500);
            }
            else {
                request(aUrl +
                    `/logout?ct=1&userId=${userInfoId}&fp=${fp}&pt=${storePtValue}&msg=${amsg}`, {
                    method: 'get',
                }).then(() => {
                    closeWindow();
                });
            }
        }
    }
}
/**
 * 关闭浏览器窗口
 */
export async function closeWindow(type) {
    console.log(type);
    if (window.sessionStorage.getItem('noclose')) {
        window.sessionStorage.removeItem('noclose');
        return;
    }
    if (window.location.pathname.includes('portal') && type == 3) {
        return;
    }
    if (navigator.userAgent.indexOf('Firefox') != -1 ||
        navigator.userAgent.indexOf('Chrome') != -1) {
        open(location, '_self')?.close();
        window.location.href = 'about:blank';
        window.close();
    }
    else {
        window.opener = null;
        window.open('', '_self');
        window.close();
        open(location, '_self')?.close();
    }
    window.close();
}
export async function saveToken(data) {
    sessionStorage.setItem(constant.access_token, data.access_token);
    sessionStorage.setItem(constant.refresh_token, data.refresh_token);
    sessionStorage.setItem(constant.expires_in, data.expires_in);
    const expires_in = dayjs().add(data.expires_in, 's').unix();
    sessionStorage.setItem(constant.token_expires_time, expires_in);
    sessionStorage.setItem(constant.user_info, JSON.stringify(data.user_info));
    sessionStorage.setItem(constant.user_name, data.user_info.name);
    localStorage.setItem('storeSessionData', JSON.stringify({
        userInfo: data.user_info,
        token: data.access_token,
    }));
    sessionStorage.setItem('pt', data.pt || '');
    if (sessionStorage.getItem(constant.user_info) &&
        sessionStorage.getItem(constant.access_token)) {
        window.location.href =
            data?.configData?.urlHref || data?.configData?.baseUrl;
    }
}
async function init(params) {
    if (!localStorage.getItem('fp')) {
        const fpPromise = FingerprintJS.load();
        (async () => {
            const fp = await fpPromise;
            const result = await fp.get();
            const { deviceMemory, ...components } = result.components;
            const visitorId = FingerprintJS.hashComponents(components);
            localStorage.setItem('fp', visitorId);
            return await authLogin(params);
        })();
    }
    else {
        return await authLogin(params);
    }
}
export const useClientAuthThing = () => {
    const configRef = useRef({
        authUrl: '',
        baseUrl: window.location.origin,
        urlHref: '',
        grant_type: 'authorization_code',
    });
    return {
        init: async function initLogin(userParams) {
            configRef.current = {
                ...configRef.current,
                authUrl: userParams.path,
                urlHref: userParams.urlHref || '',
            };
            const userInfo = await init({
                ...userParams,
                configData: configRef.current,
            });
            return userInfo;
        },
        logout: logout,
        webSocket: stompWebsocket,
    };
};
